<template>
	<div :class="{'page1': vipState === 0 || vipState === 'loginNo'}">
		<div class="headers" :class="{'newV-header': vipState === 0 || vipState === 'loginNo'}">
			<div class="headers-con" :class="{'newV-header-con': vipState === 0 || vipState === 'loginNo'}">
				<!-- 新版非会员头部 -->
				<div class="clearfix" v-if="vipState === 0 || vipState === 'loginNo'">
					<p class="header-tip">大数据显示</p>
					<p class="header-title">“ VIP金卡用户求职成功速度快<span class="header-day">3倍</span> ”</p>
					<p class="header-des">增强简历曝光、快速获得企业反馈、没有效果可获得6倍赔偿等N项特权</p>
					<div class="header-card">
						<span class="header-card-tip">尚未开通</span>
						<div class="header-buyBtn" @click="showDialog('pc-cvip-kapian-kthy-fhy')">
							<p class="buyBtn-text">开通会员尊享特权</p>
						</div>
					</div>
					<p class='header-vipProtocol'>
						查看<span class="headers-agreement" @click="showHyxy">《<i>会员服务协议</i>》</span>
					</p>
				</div>
				<!-- 会员使用中 -->
				<ul class="clearfix" v-if="vipState===1 || vipState===10">
					<li class="fl header-vipCard">
						<img :src="cardState === 20 ? require('../../../../assets/imgs/header-upgrade.png') : require('../../../../assets/imgs/header-all.png')">
						<span class="header-cardtype">{{cardState | cardType}}</span>
						<span class="header-vipUser">{{cvipMes.nickname}}</span>
					</li>
					<li class="fr header-mes">
						<!-- <p class="headers-sum">欢迎加入会员QQ群：<span>726615618</span> </p> -->
						<!-- <p class="headers-sum">今日累计{{num}}人已开通会员服务</p> -->
						<p class="headers-tit">开启应聘快车道</p>
						<p class="headers-tit">与众不同立即开始</p>
						<div class="headers-btn-wrap" @click="showDialog('pc-cvip-kapian-ljxf-hy')">
							<span class='headers-buyBtn'>{{ renew ? '立即续费' : '立即开通'}}</span>
						</div>
						<p class='headers-expri'>
							<span>会员卡有效期：{{cvipMes.expireDate}}前有效</span>
							<span class="headers-agreement" @click="showHyxy">《<i>会员协议</i>》</span>
						</p>
					</li>
				</ul>
				<!-- 过期会员 -->
				<ul class="clearfix" v-if="vipState===2">
					<li class="fl header-vipCard">
						<img src="../../../../assets/imgs/header-vipExpri.png">
						<span class="header-vipUser header-vipUserExpri">{{cvipMes.nickname}}</span>
					</li>
					<li class="fr header-mes">
						<p class="headers-tit">开启应聘快车道</p>
						<p class="headers-tit">与众不同立即开始</p>
						<div class="headers-btn-wrap" @click="showDialog('pc-cvip-kapian-ljxf-gqhy')">
							<span class='headers-buyBtn'>{{ renew ? '立即续费' : '立即开通'}}</span>
						</div>
						<p class='headers-expri'>
							<span>您的会员卡已失效{{cvipMes.outdates}}天<span v-if="renew">，现在续费立减10元</span></span>
							<span class="headers-agreement" @click="showHyxy">《<i>会员协议</i>》</span>
						</p>
					</li>
				</ul>
			</div>
		</div>
	</div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import { getVipBroadcast } from '../../../../api/index.js'
import filters from '../../../../filter/index.js'
export default {
	name: 'headers',
	props: ['vipState', 'cardState'],
	filters,
	computed: {
		...mapGetters({
			cvipMes: 'cvipMes'
		}),
		renew() {
			return this.$store.state.common.renew;
		}
	},
	data () {
		return {
			num:'',
			timerBroad: null
		}
	},
	created () {
		if (this.vipState === 0 || (this.vipState === 1 || this.vipState === 10) || this.vipState === 'loginNo') {
			// this.getVipBroadcastfn()
		}
		if(this.vipState === 1 || this.vipState === 10){
			// clearInterval(this.timerBroad)
			// this.timerBroad = setInterval(this.getVipBroadcastfn, 2000)
		}
	},
	methods: {
		getVipBroadcastfn () {
			getVipBroadcast().then((result) => {
				if (result.isSuccess){
					this.num = result.entity.num
				} else {
					console.log('网络异常', result.returnMessage)
				}
			}).catch((err) => {
				console.log('网络异常')
			})
		},
		showDialog (actionType) {
			this.$emit('showDialog')
			window.clickLog && window.clickLog(`from=${actionType}-new`)
		},
		showHyxy () {
			//（非会员 or 未登录）去掉滚动条
			// if (this.vipState === 0 || this.vipState === 'loginNo') {
			// 	document.getElementsByTagName('body')[0].style.overflow = 'hidden'
			// }
			// this.$emit('showHyxy')
			// 不展示弹窗了，改为跳转会员协议落地页
			window.open('https://helps.58.com/rules/detail?siteId=5502&terminal=PC&contentId=316237&sourceType=58pc-about&spReturn=1');
		}
	}
}
</script>
<style lang="scss" scope>
	.page1{
		height: 100%;
		width: 100%;
		position: relative;
		background: url(../../../../assets/imgs/bg-page1.png) no-repeat center;
		background-size: 100% 100%;
	}
	.headers {
		width: 100%;
		height: 450px;
		background: url(../../../../assets/imgs/header-bg.png);
		background-size: 100% 450px;
	}
	.headers-con {
		width: 715px;
		margin: 0 auto;
		padding: 72px 0 130px;
	}
	.header-vipCard {
		position: relative;
		width: 356px;
		height: 258px;
		img {
			width: 100%;
			height: 100%;
		}
	}
	.header-vipUser {
		position: absolute;
		bottom: 44px;
		left: 30px;
		font-size: 16px;
		color: #8B610B;
	}
	.header-vipUserExpri {
		font-size: 16px;
		color: #535353;
	}
	.header-mes {
		padding-top: 54px;
		font-size: 34px;
		color: #FFFFFF;
	}
	.headers-sum {
		width: 207px;
		height: 26px;
		line-height: 26px;
		background: rgba(255,255,255,0.14);
		border-radius: 0 100px 100px 0;
		font-size: 12px;
		color: #D4B277;
		text-align: center;
		span {
			color:  #FFDC76;
		}
	}
	.headers-tit {
		margin-top: 10px;
		height: 40px;
		line-height: 40px;
	}
	.headers-btn-wrap {
		overflow: hidden;
		margin-top: 30px;
		width: 210px;
		height: 44px;
		line-height: 44px;
		border-radius: 100px;
	}
	.headers-buyBtn {
		display: block;
		// margin-top: 30px;
		// width: 210px;
		// height: 44px;
		// line-height: 44px;
		filter: progid:DXImageTransform.Microsoft.Gradient(startColorStr='#fadeac',endColorStr='#C69F5D',gradientType='0');
		background-image: -webkit-linear-gradient(-179deg, #fadeac 0%, #C69F5D 100%);
		background-image: -o-linear-gradient(-179deg, #fadeac 0%, #C69F5D 100%);
		background-image: -moz-linear-gradient(-179deg, #fadeac 0%, #C69F5D 100%);
		background-image: linear-gradient(-179deg, #fadeac 0%, #C69F5D 100%);  // #F0D199
		// border-radius: 100px;
		font-size: 16px;
		color: #3F3C37;
		text-align: center;
		opacity: .9;
		cursor: pointer;
		&:hover {
			opacity: 1;
		}
	}
	.headers-expri {
		margin-top: 12px;
		font-size: 12px;
		color: #999999;
	}
	.header-cardtype {
		position: absolute;
		left: -8px;
		top: 80px;
		width: 100px;
		text-align: center;
		color: #D4B277;
		font-size: 13px;
			opacity: .8;
		-webkit-transform: rotate(-37deg);
		-ms-transform: rotate(-37deg);
		transform: rotate(-37deg);
	}
	.headers-agreement {
		i {
			text-decoration: underline;
		}
		cursor: pointer;
		&:hover {
			color: #888;
		}
	}
	//非会员新版样式
	.newV-header {
		// height: 100%;
		// width: 100%;
		height: 600px;
		position: absolute;
		top: 0;
		left: 0;
		bottom: 0;
		right: 0;
		margin: auto;
		background: transparent;
	}
	.newV-header-con{
		// height: 100%;
		width: 100%;
		padding: 0;
		.header-tip{
			font-size: 30px;
			color: #FFFFFF;
			text-align: center;
			margin-bottom: 15px;
		}
		.header-title{
			font-size: 44px;
			color: #fff;
			text-align: center;
			line-height: 50px;
			font-weight: 500;
			font-family: Arial;
		}
		.header-day {
			color: #E6CA98;
		}
		.header-des{
			opacity: 0.5;
			font-size: 20px;
			color: #FFFFFF;
			text-align: center;
			margin: 15px 0;
		}
		.header-card{
			height: 374px;
			width: 518px;
			background: url(../../../../assets/imgs/header-card.png) no-repeat center;
			background-size: 100% 100%;
			margin: 0 auto;
			position: relative;
			.header-card-tip{
				display: inline-block;
				color: #fff;
				position: absolute;
				right: 50px;
				top: 78px;
				font-size: 14px;
				transform: rotate(42deg);
				-ms-transform: rotate(42deg); 	/* IE 9 */
				-moz-transform: rotate(42deg); 	/* Firefox */
				-webkit-transform: rotate(42deg); /* Safari 和 Chrome */
				-o-transform: rotate(42deg); 	/* Opera */
			}
			.header-buyBtn {
				width: 428px;
				height: 95px;
				margin: 0 auto;
				background: url(../../../../assets/imgs/buybtn.png) no-repeat center;
				background-size: 100% 100%;
				position: absolute;
				left: 0;
				right: 0;
				top: 255px;
				&:hover {
					background: url(../../../../assets/imgs/buybtn-hover.png) no-repeat center;
					background-size: 100% 100%;
					cursor: pointer;
				}
			}
			.buyBtn-text{
				height: 50px;
				line-height: 50px;
				padding-top: 14px;
				font-weight: bold;
				font-size: 16px;
				color: #403C36;
				letter-spacing: 0;
				text-align: center;
				text-shadow: 0 1px 0 rgba(255,255,255,0.22);
			}
		}
		.header-vipProtocol{
			opacity: 0.5;
			font-size: 14px;
			color: #FFFFFF;
			letter-spacing: 0;
			text-align: center;
			margin-top: 45px;
		}
	}
</style>



// WEBPACK FOOTER //
// Header.vue?732ee083